module.exports = __webpack_public_path__ + "static/IMG_2291-c73eb47198e2c4c93d3d09a746ad2055.jpg";